import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'

export interface ChipItem {
  label: string
  icon?: string
  value: any
}

export enum ChipSelectorMode {
  Single = 'single',
  Multiple = 'multiple',
}

@Component({
  selector: 'basin-chip-selector',
  templateUrl: './chip-selector.component.html',
  styleUrls: ['./chip-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ChipSelectorComponent),
      multi: true,
    },
  ],
})
export class ChipSelectorComponent implements ControlValueAccessor {
  @Input() styleClass: string
  @Input() chipList: ChipItem[] = []
  @Input() selectionMode: ChipSelectorMode = ChipSelectorMode.Single
  @Input() ngModel: ChipItem[] = []
  @Output() ngModelChange: EventEmitter<ChipItem[]> = new EventEmitter<
    ChipItem[]
  >()
  onModelChange: Function = () => {}
  onModelTouched: Function = () => {}

  constructor(private cdRef: ChangeDetectorRef) {}

  writeValue(selected: ChipItem[]): void {
    this.ngModel = selected
    this.cdRef.markForCheck()
  }
  registerOnChange(fn: any): void {
    this.onModelChange = fn
  }
  registerOnTouched(fn: any): void {
    this.onModelTouched = fn
  }

  checkIfSelected(chip: ChipItem) {
    return this.ngModel?.some(
      (selectedChip) => JSON.stringify(selectedChip) === JSON.stringify(chip)
    )
  }

  setToggleType(chip: ChipItem): string {
    if (this.selectionMode === ChipSelectorMode.Multiple) {
      return 'toggle'
    } else {
      return this.checkIfSelected(chip) ? undefined : 'toggle'
    }
  }

  selectChip(chip: ChipItem) {
    if (this.selectionMode === ChipSelectorMode.Single) {
      this.ngModel = [chip]
    } else {
      if (
        this.ngModel.some(
          (selectedChip) =>
            JSON.stringify(selectedChip) === JSON.stringify(chip)
        )
      ) {
        this.ngModel = this.ngModel.filter(
          (selectedChip) =>
            JSON.stringify(selectedChip) !== JSON.stringify(chip)
        )
      } else {
        this.ngModel = [...this.ngModel, chip]
      }
    }
    this.onModelChange(this.ngModel)
    this.onModelTouched()
    this.cdRef.markForCheck()
  }
}
